import { MIME_TYPES } from '@inno-sdks/mime-types'

export const readableFileTypes = {
  [MIME_TYPES.docx]: 'word-document',
  [MIME_TYPES.doc]: 'word-document',
  [MIME_TYPES.docm]: 'word-document',
  [MIME_TYPES.dot]: 'word-template',
  [MIME_TYPES.dotm]: 'word-template',
  [MIME_TYPES.dotx]: 'word-template',
  [MIME_TYPES.odt]: 'opendocument-text',
  [MIME_TYPES.ott]: 'text-template',
  [MIME_TYPES.rtf]: 'rich-text-document',
  [MIME_TYPES.epub]: 'ebook-file',
  [MIME_TYPES.fb2]: 'fictionbook-file',
  [MIME_TYPES.fodt]: 'flat-text-document',
  [MIME_TYPES.hwp]: 'hangul-document',
  [MIME_TYPES.hwpx]: 'hangul-document',
  [MIME_TYPES.md]: 'markdown-file',
  [MIME_TYPES.mht]: 'web-archive',
  [MIME_TYPES.mhtml]: 'web-archive',
  [MIME_TYPES.pages]: 'pages-document',
  [MIME_TYPES.stw]: 'text-template',
  [MIME_TYPES.sxw]: 'writer-document',
  [MIME_TYPES.wps]: 'works-document',
  [MIME_TYPES.wpt]: 'works-document',

  [MIME_TYPES.txt]: 'text-file',
  [MIME_TYPES.vtt]: 'subtitle-file',
  [MIME_TYPES.xml]: 'xml-file',
  [MIME_TYPES.html]: 'html-document',
  [MIME_TYPES.htm]: 'html-document',

  [MIME_TYPES.ods]: 'opendocument-spreadsheet',
  [MIME_TYPES.fods]: 'flat-spreadsheet',
  [MIME_TYPES.csv]: 'csv-file',
  [MIME_TYPES.xls]: 'excel-spreadsheet',
  [MIME_TYPES.xlsx]: 'excel-spreadsheet',
  [MIME_TYPES.xltx]: 'excel-template',
  [MIME_TYPES.et]: 'kingsoft-spreadsheet',
  [MIME_TYPES.ett]: 'kingsoft-spreadsheet-template',
  [MIME_TYPES.numbers]: 'numbers-spreadsheet',
  [MIME_TYPES.ots]: 'opendocument-spreadsheet-template',
  [MIME_TYPES.sxc]: 'calc-spreadsheet',
  [MIME_TYPES.xlsb]: 'excel-binary-spreadsheet',
  [MIME_TYPES.xlsm]: 'excel-spreadsheet',
  [MIME_TYPES.xltm]: 'excel-template',

  [MIME_TYPES.pdf]: 'pdf',
  [MIME_TYPES.djvu]: 'djvu-document',
  [MIME_TYPES.oxps]: 'xps-document',
  [MIME_TYPES.xps]: 'xps-document',

  [MIME_TYPES.vsdx]: 'visio-drawing',
  [MIME_TYPES.vsdm]: 'visio-drawing',
  [MIME_TYPES.vssx]: 'visio-stencil',
  [MIME_TYPES.vssm]: 'visio-stencil',
  [MIME_TYPES.vstx]: 'visio-template',
  [MIME_TYPES.vstm]: 'visio-template',

  [MIME_TYPES.excalidraw]: 'drawing',

  [MIME_TYPES.ppt]: 'powerpoint',
  [MIME_TYPES.pptx]: 'powerpoint',
  [MIME_TYPES.pptm]: 'powerpoint',
  [MIME_TYPES.odp]: 'opendocument-presentation',
  [MIME_TYPES.fodp]: 'flat-presentation',
  [MIME_TYPES.potx]: 'powerpoint-template',
  [MIME_TYPES.sxi]: 'impress-presentation',
  [MIME_TYPES.dps]: 'kingsoft-presentation',
  [MIME_TYPES.dpt]: 'kingsoft-presentation-template',
  [MIME_TYPES.key]: 'keynote-presentation',
  [MIME_TYPES.odg]: 'opendocument-graphics',
  [MIME_TYPES.otp]: 'opendocument-presentation-template',
  [MIME_TYPES.pot]: 'powerpoint-template',
  [MIME_TYPES.potm]: 'powerpoint-template',
  [MIME_TYPES.ppsm]: 'powerpoint-slideshow',
  [MIME_TYPES.ppsx]: 'powerpoint-slideshow',

  [MIME_TYPES.png]: 'png-image',
  [MIME_TYPES.bmp]: 'bmp-image',
  [MIME_TYPES.gif]: 'gif-image',
  [MIME_TYPES.jpg]: 'jpeg-image',
  [MIME_TYPES.tif]: 'tiff-image',
  [MIME_TYPES.svg]: 'svg-image',
  [MIME_TYPES.pjpeg]: 'jpeg-image',
  [MIME_TYPES.webp]: 'webp-image',
  [MIME_TYPES.wbmp]: 'wbmp-image',
  [MIME_TYPES.ico]: 'icon',
  [MIME_TYPES.cur]: 'icon',
  [MIME_TYPES.heif]: 'heif-image',
  [MIME_TYPES.heic]: 'heic-image',
  [MIME_TYPES.pbm]: 'bitmap-image',
  [MIME_TYPES.pgm]: 'grayscale-image',
  [MIME_TYPES.ppm]: 'pixmap-image',
  [MIME_TYPES.xpm]: 'x-pixmap',
  [MIME_TYPES.avif]: 'avif-image',

  [MIME_TYPES.mp3]: 'mp3-audio',
  [MIME_TYPES.wav]: 'wav-audio',
  [MIME_TYPES.aac]: 'aac-audio',
  [MIME_TYPES.ogg]: 'ogg-audio',
  [MIME_TYPES.flac]: 'flac-audio',
  [MIME_TYPES.m4a]: 'm4a-audio',
  [MIME_TYPES.wma]: 'wma-audio',
  [MIME_TYPES.aiff]: 'aiff-audio',
  [MIME_TYPES.aif]: 'aiff-audio',
  [MIME_TYPES.au]: 'basic-audio',
  [MIME_TYPES.weba]: 'webm-audio',
  [MIME_TYPES.midi]: 'midi-audio',
  [MIME_TYPES.amr]: 'amr-audio',

  [MIME_TYPES.mp4]: 'mp4-video',
  [MIME_TYPES.mpeg]: 'mpeg-video',
  [MIME_TYPES.avi]: 'avi-video',
  [MIME_TYPES.webm]: 'webm-video',
  [MIME_TYPES.mov]: 'mov-video',
  [MIME_TYPES['3gp']]: '3gpp-video',
  [MIME_TYPES['3g2']]: '3gpp2-video',
  [MIME_TYPES.ogv]: 'ogg-video',
  [MIME_TYPES.wmv]: 'wmv-video',
  [MIME_TYPES.flv]: 'flv-video',
  [MIME_TYPES.asf]: 'asf-video',
  [MIME_TYPES.wmx]: 'wmx-video',
  [MIME_TYPES.wvx]: 'wvx-video',
  [MIME_TYPES.mkv]: 'mkv-video',
  [MIME_TYPES.m4v]: 'm4v-video',
  [MIME_TYPES.m3u8]: 'hls-stream',
  [MIME_TYPES.ts]: 'mpeg-ts-video',

  [MIME_TYPES.zip]: 'zip-archive',
  [MIME_TYPES.tar]: 'tar-archive',
  [MIME_TYPES.rar]: 'rar-archive',
  [MIME_TYPES['7z']]: '7zip-archive',
  [MIME_TYPES.gz]: 'gzip-archive',
  [MIME_TYPES.bz2]: 'bzip2-archive',
  [MIME_TYPES.xz]: 'xz-archive',
  [MIME_TYPES.lzma]: 'lzma-archive',
  [MIME_TYPES.lzip]: 'lzip-archive',
  [MIME_TYPES.lzop]: 'lzop-archive',
  [MIME_TYPES.zst]: 'zstandard-archive',
  [MIME_TYPES.cpio]: 'cpio-archive',
  [MIME_TYPES.iso]: 'iso-disk-image',
  [MIME_TYPES.z]: 'unix-compress-archive',
  [MIME_TYPES.zlib]: 'zlib-archive',

  [MIME_TYPES.psw]: 'postscript',
  [MIME_TYPES.cda]: 'cd-audio',
  [MIME_TYPES.dbf]: 'database-file',
  [MIME_TYPES.odc]: 'opendocument-chart',
  [MIME_TYPES.swf]: 'flash-file',
  [MIME_TYPES.pub]: 'publisher-document',
  [MIME_TYPES.woff]: 'web-font',
  [MIME_TYPES.sit]: 'stuffit-archive',
  [MIME_TYPES.wmf]: 'wmf-image',
  [MIME_TYPES.pntg]: 'macpaint-image',
  [MIME_TYPES.psd]: 'photoshop-image'
} as const
